import { gql } from '@apollo/client';

export const COMPLETE_ONBOARDING_STEP = gql`
  mutation CompleteOnboardingStep($step: Int!) {
    completeOnboardingStep(step: $step) {
      id
      currentStep
      completedSteps
    }
  }
`;
